export default "__VITE_ASSET__CFQuHdW0__"